/** @jsx jsx */
import { jsx } from '@emotion/core';

export function SliderAwardItem(props){
    //Dumy only for cms edit item
    return(
        <div></div>
    )
}